import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PaperClipRegularDiagonal from './paper-clip-regular-diagonal-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PaperClipRegularDiagonal {...validProps} />;
}
SvgComponent.iconName = 'paperClipRegularDiagonal';

export const PaperClipRegularDiagonalIcon = svgIconWrapper(SvgComponent);
